import { useCallback, useEffect, useState, useRef } from 'react';
import styles from './AboutMe.module.css';

import { motifPaths } from '../data/motifs.js'
import LandAcknowledgement from './LandAcknowledgement.js';

import Tooltip from './Tooltip.js';
import MiniNav from './MiniNav.js';
import FavouriteThings from './FavouriteThings.js';

const motifs = motifPaths;
const antiAI = "Generative AI's greatest advocates are tech and political oligarchs using their influence to dismantle everyday people's trust, devalue information, so they can continue to extract labour and resources from the working class – all built on infrastructure that is rapidly consuming electric and water reserves.";

const warningPath = motifPaths.warning.path;

const aboutMiniNavLinks = [
    { id: "aboutLinkDesign", link: "#design", linkText: "Design", linkTitle: "View Design Folio", targetUp: false, specialLink: false },
    { id: "aboutLinkIllustration", link: "#illustration", linkText: "Illustration", linkTitle: "View Illustration Folio", targetUp: false, specialLink: false },
    { id: "aboutLinkServices", link: "#services", linkText: "+more professional services", linkTitle: "View list of services.", targetUp: false, specialLink: true }
]

function AboutMe() {

    return (

        <div id="about" className={styles.aboutMe}>
            <MiniNav miniNavLinkArray={aboutMiniNavLinks} />

            <div className={styles.mainSection}>
                <div className={styles.mainSectionBio}>
                    <h2 className={styles.aboutMeHeading}>Hello! I'm Jon.</h2>
                    <p className={styles.aboutMeDescription}>
                        I’m a graphic designer + illustrator with over a decade of experience in print and digital production. I’m passionate about the stories we tell through the experiences we create.
                    </p>
                    <p className={styles.aboutMeDescription}>
                        I enjoy making events, presentations, printed things, things on screens, stories – anything really! – feel special. If you have someone you want to celebrate, or a product you really believe in, shoot me an <a title="Send an email to design@jlliew.com" href="mailto:design@jlliew.com" tabIndex="0">email.</a>
                    </p>
                    {/*/}FavouriteThings />*/}
                    {/*Have a look at my <a tabIndex="0" title="View list of services." href="#services">list of services</a>.*/}


                    {/* 
                    <p className={styles.aboutMeDescription}>
                        I enjoy making things feel special, with a
                        <Tooltip
                            text={
                                <p className={styles.fuckAI}>
                                    <svg className={styles.fuckAIMotif}>{warningPath}</svg>
                                    <strong>F**K AI.</strong> When you use generative AI, you're telling your audience you don't care about them, or your message. That's fine, but it's also part of the surveillance apparatus that is actively encroaching on our civil rights, and our access to important things like water.
                                </p>
                            }
                            position="top">human touch
                        </Tooltip>.
                    </p>
                    */}




                    <p></p>
                </div>
            </div>
            {/*<div className={styles.subSections}>
                {/*<p className={styles.WIPNote}>* I'm still gathering bits to put this site together. But hey, thanks for visiting!</p>
                <h3 className={styles.aboutSectionHeading}>Design</h3>

                <div className={styles.aboutProcess}>
                    <p className={styles.processIntro}>Every project is different. Click below for a rough idea of how the process might work.</p>
                </div>
                <div className={styles.aboutProcessCapsules}>
                    <button tabIndex="0" className={styles.aboutProcessCapsuleLink}
                    //onPointerDown={ }
                    ><span className={styles.aboutProcessCapsule}>Design / Illustration</span></button>
                    <button tabIndex="0" className={styles.aboutProcessCapsuleLink}
                    //onPointerDown={ }
                    ><span className={styles.aboutProcessCapsule}>Production / Events</span></button>
                </div>

                <div className={styles.processSteps}>
                    <h3 className={styles.processStepTitle}>01. Contact & scope</h3>
                    <p className={styles.processStepDescription}>Every project is different. Get in touch with your brief and budget, and we can chat about next steps.</p>

                    <h3 className={styles.processStepTitle}>02. Discovery</h3>
                    <p className={styles.processStepDescription}>Every project is different. Get in touch with your brief and budget, and we can chat about next steps.</p>

                    <h3 className={styles.processStepTitle}>03. Execute</h3>
                    <p className={styles.processStepDescription}>Every project is different. Get in touch with your brief and budget, and we can chat about next steps.</p>
                </div>
            </div>*/}
        </div>

    );
}

export default AboutMe;
